import { Action, ActionReducerMap } from '@ngrx/store';

import * as fromProjectData from './project-data/project-data.reducer';
import * as fromProductView from './product-view/product-view.reducer';
import * as fromProductContext from './product-context/product-context.reducer';
import { ProjectState } from './project.state';

export const projectReducer: ActionReducerMap<ProjectState, Action> = {
  projectDataState: fromProjectData.reducer,
  productViewState: fromProductView.reducer,
  productContextState: fromProductContext.reducer
};
